import { CopyOutlined } from '@ant-design/icons'
import { SspBean } from 'common/api/api.ts'
import { CopyToClipboardButton } from 'common/components/CopyToClipboardButton.tsx'
import { GoToReportButton } from 'common/components/GoToReportButton.tsx'
import { ListActionButton } from 'common/components/ListActionButton.tsx'
import { CommonRoutes } from 'common/context/commonRoutes.ts'
import React from 'react'
import { useNavigate } from 'react-router-dom'

interface Props {
  record: SspBean
}

const getSspUrl = (record: SspBean) => {
  const protocol = import.meta.env.VITE_PROTOCOL
  const url = import.meta.env.VITE_BIDDER_ENDPOINT
  return `${protocol}//${url}/bid/${record.endpoint}`
}

export const SspActionBar: React.FC<Props> = ({ record }) => {
  const navigateTo = useNavigate()

  return (
    <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
      <GoToReportButton title="Report Builder" filterName="SspId" id={record.id} />
      <CopyToClipboardButton text={getSspUrl(record)} />
      <ListActionButton tooltip="Duplicate" onClick={() => navigateTo(`${CommonRoutes.SSP_COPY}/${record.id}`)}>
        <CopyOutlined />
      </ListActionButton>
    </div>
  )
}
